










 

 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewMeetingSettingsToggleCheckIn_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phaseTypes",
      "storageKey": null
    }
  ],
  "type": "TeamMeetingSettings",
  "abstractKey": "__isTeamMeetingSettings"
};

(node ).hash = "efd73428f9e15508c2b2092e2469581f";

export default node;
